export default {
    template: `<b>{{ displayValue }}</b>`,
    data: () => ({
        displayValue: null
    }),
    beforeMount() {
        this.displayValue = this.params.valueFormatted;
    },
 };